import client from "../client";

export interface GetTransactionRPSRoomRequest {
  transaction_rps_game_bet_id?: number | undefined;
}

export interface GetTransactionRPSRoomRepsonse {
  Hash_key?: string;
  Bet_round_id?: string;
  Games?: number;
  Name_th?: string;
  Name_en?: string;
  Amount?: number;
  Uncalculated?: boolean;
  Transaction_rpsgame_result_id?: number;
  Username?: string;
  Created_at?: Date;
  Updated_at?: Date;
  DisplayCreatedAt?: string;
  DisplayUpdatedAt?: string;
}

export default function API(
  request: GetTransactionRPSRoomRequest
): Promise<GetTransactionRPSRoomRepsonse[]> {
  return client
    .get(`gameinhouse/rps/get_transaction_rps_room`, { params: request })
    .then((response) => response.data);
}
